import { render } from "./SuccessInitialHoldModal.vue?vue&type=template&id=52b8079c&scoped=true&ts=true&lang=pug"
import script from "./SuccessInitialHoldModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./SuccessInitialHoldModal.vue?vue&type=script&setup=true&lang=ts"

import "./SuccessInitialHoldModal.vue?vue&type=style&index=0&id=52b8079c&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52b8079c"]])

export default __exports__